import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DiagnosisContent from '../components/DiagnosisContent';

const PeriodontalDiagnosis = () => {
  return (
    <div className="periodontal-diagnosis-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <DiagnosisContent />
      <Footer />
    </div>
    );
};

export default PeriodontalDiagnosis;